// src\routes\authRoutes.tsx
import { RouteObject } from "react-router-dom";
import { lazy, Suspense } from "react";
import Loader from "../components/CustomLoader";
import { AuthLayout, } from "../layouts";
// import LayoutWrapper from "../layouts/LayoutWrapper";
// import LoaderFallback from "../components/LoaderFallback";

const Login = lazy(() => import("../pages/Auth/Login"));
const ForgotPassword = lazy(() => import("../pages/Auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/Auth/ResetPassword"));
const ForgetPasswordOTPVerificaion = lazy(() => import("../pages/Auth/ForgetPasswordOTPVerification"));
const LoginOTPVerification = lazy(() => import("../pages/Auth/LoginOTPVerification"));
const CustomerLogin = lazy(() => import("../pages/Customer/Login"));


const withSuspense = (Component: React.FC) => (
  <Suspense fallback={<Loader force={true} />}>
    {/* <Suspense fallback={<LoaderFallback />}> */}
    <Component />
  </Suspense>
);



export const authRoutes: RouteObject[] = [
  {
    path: "/",
    element: <AuthLayout />,
    children: [
      { path: "", element: withSuspense(Login) },
      { path: "login", element: withSuspense(Login) },
      { path: "forgot-password", element: withSuspense(ForgotPassword) },
      { path: "reset-password", element: withSuspense(ResetPassword) },
      { path: "verify-otp", element: withSuspense(ForgetPasswordOTPVerificaion) },
      { path: "verify-login-otp", element: withSuspense(LoginOTPVerification) },
      // Customer login route only
      { path: "customer/login", element: withSuspense(CustomerLogin) },
    ],
  },
]